import { createSlice } from "@reduxjs/toolkit"

// http client
import client from "../../lib/client"
import { ledgerAccountsImportUrl, ledgerFieldsImportUrl, divisionImportUrl, vendorsImportUrl, arcadiaProxyApi, directUploadUrl, arcadiaPdfUrlApi, proxyUrl, clientUrl, alaiUrl, duplicateEntryCheckUrl } from "../../lib/endpoints"
import { notification } from "antd"
import { DirectUpload } from "@rails/activestorage"
import { getClient, getToken, getUid } from "../../lib/storage"
import axios from "axios"
// import { setAlerts } from "../nav/alertPanelSlice"
const alaiCreds = btoa(process.env.REACT_APP_ALAI_CREDENTIALS)

export const importsSlice = createSlice({
    name: "imports",
    initialState: {
        arcadiaInfo: [],
        // division: {},
        // divisions: [],
        // divisionSelectOptions: [],
        // divisionSearch: [],
        // batchGroupSelectOptions: [],
        total: 0,
        pagination: { current: 1, pageSize: 10 },
        loading: false,
    },
    reducers: {
        setArcadiaInfo: (state, action) => {
            state.arcadiaInfo = action.payload
            state.total = action.payload.length
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
    },
})

// export const { setDivision, setDivisions, setPagination, setLoading, setDivisionSelectOptions, setDivisionSearch, setBatchGroupSelectOptions } = divisionsSlice.actions
export const { importFile, setArcadiaInfo, setLoading } = importsSlice.actions
// importFile

// const getEndpointForDataType = (dataType) => {
//     switch (dataType) {
//         case "ledger_account":
//             return ledgerAccountsImportUrl
//         case "ledger_fields":
//             return ledgerFieldsImportUrl
//         case "divisions":
//             return divisionImportUrl
//         case "vendors":
//             return vendorsImportUrl    
//         // case "index":
//         //     return renderIndex()
//         // case "import":
//         //     return renderImport()
//         // case "form":
//         //     return renderForm()
//         // case "facilities":
//         //     return renderFacilities()
//         // case "facilities-form":
//         //     return renderFacilitiesForm()
//         // case "documents":
//         //     return renderDocuments()
//         // case "documents-form":
//         //     return renderDocumentsForm()
//         default:
//             return renderDashboard()
//     }
// }

// export function importFile(values, id) {
//     return async (dispatch) => {
//         const response = await client.post(divisionsUrl, values)
//         // return response.data

//         const response = await client({
//             method: "post",
//             url: getEndpointForDataType(dataType),
//             data: bodyFormData,
//             config: {
//                 headers: {
//                     "Content-Type": "multipart/form-data",
//                 },
//             },
//         })
//     }
// }

export async function fetchAlaiBillFile(id) {
    const response = await fetch(`${alaiUrl}/bills/${id}/file`, {
        method: "GET",
        headers: {
            Authorization: `Basic ${alaiCreds}`,
        },
    })

    if (!response.ok) throw new Error("Failed to fetch PDF")

    return response.blob()
}

async function fetchAndUploadPDF(urlInfo) {
  try {
    const { clientCode, accNum, id } = urlInfo
    const filename = urlInfo.filename.replaceAll(" ", "_")

    const blob = await fetchAlaiBillFile(id)
    const file = new File([blob], `${filename}.pdf`, { type: "application/pdf" })
    const upload = new DirectUpload(file, process.env.REACT_APP_RAILS_STORAGE_URL)

    const signedId = await new Promise((resolve, reject) => {
        upload.create((error, blob) => {
            if (error) {
                console.error("Upload failed", error)
                reject(error)
            } else {
                resolve(blob.signed_id)
            }
        })
    })

    return { file: signedId };
  } catch (err) {
    console.error("Something went wrong", err)
    return { file: '' }
  }
}

function formatDate(date){
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    return `${month}-${day}-${year}`
}

// TODO: Change name now that arcadia isnt being used anymore.
export function fetchArcadiaInfo(type, id) {
    return async (dispatch, getState) => {
        dispatch(setLoading(true))
        const clientInfo = await client.get(clientUrl(id))
        let alaiRes = []
        let arcadiaBills = []

        try {
            alaiRes = await fetch(`${alaiUrl}/bills/client/${clientInfo.data.identifier}`, {
                method: "GET",
                headers: {
                    Authorization: `Basic ${alaiCreds}`,
                },
            }).then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok " + response.statusText)
                }
                if (response.status === 204) {
                    return []
                }
                return response.json()
            })
        } catch (e) {
            // console.error("ALAI ERROR", e)
        }

        const duplicatesCheck = await client.post(duplicateEntryCheckUrl(id), { data: alaiRes })
        const { new_bills, duplicates, duplicate_ids } = duplicatesCheck.data

        if (duplicates && duplicates.length > 0) {
            const callback = await fetch(`${alaiUrl}/bills/callback/bulk`, {
                method: "POST",
                headers: {
                    Authorization: `Basic ${alaiCreds}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    results: duplicates,
                }),
            }).then((response) => {
                // console.log(response)
                if (!response.ok) {
                    throw new Error("Network response was not ok " + response.statusText)
                }
                return response.json()
            })
        }
        const result = new_bills
        // const result = alaiRes

        dispatch(setArcadiaInfo(result))
        dispatch(setLoading(false))
    }
}


export function createArcadiaImport(url, data){
    return async (dispatch, getState) => {
        dispatch(setLoading(true))
        const bills = []
        const callBackInfo = []
        for (let i = 0; i < data.length; i++) {
            const bill = data[i]
            const { client_id, account_number, id, bill_date, blob_url } = bill

            const clientCode = client_id ? client_id : parseInt(bill.client.split(" ")[0])
            const billDate = new Date(bill_date)
            const MM = billDate.getMonth() + 1
            const dd = billDate.getDate()
            const filename = `${clientCode}.${MM >= 10 ? MM : `0${MM}`}.${dd >= 10 ? dd : `0${dd}`}_${account_number.slice(-6)}_MD`
            const getFile = await fetchAndUploadPDF({ filename: filename, clientCode: clientCode, accNum: account_number, blob: blob_url, id: bill.id })
            const file = getFile.file
            bills.push({ ...bill, file: file })
            // callBackInfo.push({bill_id: bill.id, message: "Successfully imported", status: 'success'})
        }

        // console.log(bills)
        const response = await client.post(url, { data: bills }).catch(async (e) => {
            const { bills, error_msg, failed, wrong_meter } = e.response.data
            notification.error({
                duration: 10,
                message: "Error",
                description: (
                    <>
                        <div>{error_msg}</div>
                        <br />
                        <div>Acc Num | Bill Date | Curr Chgs</div>
                        <ul>
                            {bills.map((bill, index) => (
                                <li key={index} style={{ color: "black" }}>
                                    {bill.account_number} | {new Date(bill.bill_date).toLocaleDateString("en-US")} | {bill.current_charges}
                                    {bill.errors && `\n-- Issue(s): ${bill.errors}`}
                                </li>
                            ))}
                        </ul>
                        {wrong_meter && wrong_meter.length > 0 && (
                            <>
                                <hr />
                                <div>The following bills have an incorrect meter number that need to be updated for successful import:</div>
                                <br />
                                <div>Acc Num | Meter Num</div>
                                <ul>
                                    {bills.map((bill, index) => (
                                        <li key={index} style={{ color: "black" }}>
                                            {bill.account_number} | {bill.meter_number_1}
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                    </>
                ),
            })
            const callback = await fetch(`${alaiUrl}/bills/callback/bulk`, {
                method: "POST",
                headers: {
                    Authorization: `Basic ${alaiCreds}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    results: failed,
                }),
            }).then((response) => {
                // console.log(response)
                if (!response.ok) {
                    throw new Error("Network response was not ok " + response.statusText)
                }
                return response.json()
            })
            return "error"
        })
        if(response && response != 'error'){
            // console.log(response)
            const { successful, bills, error_msg, failed } = response.data
            // console.log(successful)
            if(error_msg){
                notification.warning({
                    duration: 10,
                    message: "Import partially successful",
                    description: (
                        <>
                            <div>{error_msg}</div>
                            <br />
                            <div>Acc Num | Bill Date | Curr Chgs</div>
                            <ul>
                                {bills.map((bill, index) => (
                                    <li key={index} style={{ color: "black" }}>
                                        {bill.account_number} | {new Date(bill.bill_date).toLocaleDateString("en-US")} | {bill.current_charges}
                                        {bill.errors && `\n-- Issue: ${bill.errors}`}
                                        {/* {index != bills.length - 1 && "-----------------------"} */}
                                    </li>
                                ))}
                            </ul>
                        </>
                    ),
                })
                if(failed && failed.length > 0){
                    const callback = await fetch(`${alaiUrl}/bills/callback/bulk`, {
                        method: "POST",
                        headers: {
                            Authorization: `Basic ${alaiCreds}`,
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            results: failed.concat(successful),
                        }),
                    }).then((response) => {
                        // console.log(response)
                        if (!response.ok) {
                            throw new Error("Network response was not ok " + response.statusText)
                        }
                        return response.json()
                    })               
                }
            }
            else{
                notification.success({
                    duration: 10,
                    message: "Import successful!",
                    description: "The import has been made successfully.",
                })
                if(successful && successful.length > 0){
                    const callback = await fetch(`${alaiUrl}/bills/callback/bulk`, {
                        method: "POST",
                        headers: {
                            Authorization: `Basic ${alaiCreds}`,
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            results: successful,
                        }),
                    }).then((response) => {
                        // console.log(response)
                        if (!response.ok) {
                            throw new Error("Network response was not ok " + response.statusText)
                        }
                        return response.json()
                    })               
                }
            }
            if(error_msg){
                dispatch(setArcadiaInfo(bills))
                dispatch(setLoading(false))
                return "error"
            }
        }
        dispatch(setLoading(false))
        return response
    }
}

// Change this to ignore instead of deleted
export function deleteImportBills(bills) {
    return async (dispatch, getState) => {
        dispatch(setLoading(true))
        const callback = await fetch(`${alaiUrl}/bills/callback/bulk`, {
            method: "POST",
            headers: {
                Authorization: `Basic ${alaiCreds}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                results: bills,
            }),
        }).then((response) => {
            // console.log(response)
            if (!response.ok) {
                throw new Error("Network response was not ok " + response.statusText)
            }
            return response.json()
        })
        dispatch(setLoading(false))
    }
}

export const selectArcadiaInfo = (state) => state.imports.arcadiaInfo
export const selectTotal = (state) => state.imports.total
export const selectPagination = (state) => state.imports.pagination
export const selectLoading = (state) => state.imports.loading

// export const selectDivision = (state) => state.divisions.division
// export const selectDivisions = (state) => state.divisions.divisions
// export const selectTotal = (state) => state.divisions.total
// export const selectDivisionSelectOptions = (state) => state.divisions.divisionSelectOptions
// export const selectDivisionSearch = (state) => state.divisions.divisionSearch
// export const selectBatchGroupSelectOptions = (state) => state.divisions.batchGroupSelectOptions

export default importsSlice.reducer
